import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import './global.scss'
import { toast } from 'react-toastify'
import { FadeLoader } from 'react-spinners';
import axios from 'axios';
function CanaderRedirect() {

    const [searchParams] = useSearchParams();
    const [isLoading,setIsLoading] = useState(false)
    const navigate = useNavigate()
    useEffect(()=>{
        handleRedirect();      
    // eslint-disable-next-line
    },[])

    const handleRedirect = async ()=>{
        setIsLoading(true)
     
        const referenceId = searchParams.get('referenceId');
        const id = searchParams.get('id');
      
       
      try{

        if(referenceId){
            const url = `https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/canada/payment-status/${referenceId}`
            const res = await axios.get(url);
           
            setIsLoading(false)
            const status = res.data?.data?.status || res.data?.data?.data?.status
            
            if(!status) return navigate('/pages/canada-failed');
            if(status==="Processed" || status==="Settled"){
                navigate('/pages/canada-success')
                // console.log("status: ",status)
            }else if(status === "Processing" || status==="Pending"){
                navigate('/pages/canada-pending')
            }else if(status === "Cancelled" || status === "Expired" || status === "Declined" || status === "Failed" ){
                navigate('/pages/canada-failed')
            } else {
                navigate('/pages/canada-failed')
            }
        }else if(id){
            const url = `https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/canada/payment-status/${id}`
            const res = await axios.get(url);
            console.log("response status: ",res.data)
            setIsLoading(false)
            const status = res.data?.data?.status || res.data?.data?.data?.status
            
            if(!status) return navigate('/pages/canada-failed');
            if(status==="Processed" || status==="Settled"){
                navigate('/pages/canada-success')
                // console.log("status: ",status)
            }else if(status === "Processing" || status==="Pending"){
                navigate('/pages/canada-pending')
            }else if(status === "Cancelled" || status === "Expired" || status === "Declined" || status === "Failed" ){
                navigate('/pages/canada-failed')
            } else {
                navigate('/pages/canada-failed')
            }
        }else {
            navigate ('/pages/canada-failed')
        }
  
        // console.log("response Data: ",res.data);
          
      }catch(err){
          setIsLoading(false)
          console.log(err);
          navigate('/pages/canada-failed')
      }
  
    }

    // const handleClick =()=>{
    //     navigate('/pages/canada')
    // }
  return (
    <div className="loader">
        <div className='loading_overlay' style={{background:"#e9e9e9"}}>
        
            {
                isLoading &&
                <FadeLoader
                cssOverride={{marginRight:"auto",marginLeft:"auto"}}
                color="#259792"
                />
            }
            
        </div>
    </div>
  )
}

export default CanaderRedirect